import { BaseSectionCreator } from './baseSectionCreator';
import { IItemSection, ItemSection, SectionType } from '../itemSection';
import { Product } from '@/store/modules/product';
import store from '@/store';
import { ElementType } from '../element';
import { bedsideTableLegs } from '../legs/bedsideTableLegs';

export class BedsideTableSectionCreator extends BaseSectionCreator {

    protected sections: IItemSection[] = [
        new ItemSection(SectionType.BODY_COLOR, 'Kolor korpusu', []),
        new ItemSection(SectionType.FRONT_COLOR, '', []),
        new ItemSection(SectionType.LEGS, 'nóżki', []),
        new ItemSection(SectionType.HANDLES, '', []),
    ];

    constructor(
        scenePreview: any,
    ) {
        super(scenePreview);
    }

    public create(product: Product): IItemSection[] {
        this.applyLanguage();
        const furnitureShaders = store.getters.shaders.furniture;
        this.updateShaderSection(SectionType.BODY_COLOR, ElementType.BODY, furnitureShaders);
        this.updateFrontsSection(furnitureShaders);
        this.updateLegsSection(product, bedsideTableLegs);
        this.updateHandlesSection();
        return this.sections;
    }

    protected applyLanguage(): void {
        this.getSectionByType(SectionType.BODY_COLOR).text = this.scenePreview.$t('bodyColor');
        this.getSectionByType(SectionType.FRONT_COLOR).text = this.scenePreview.$t('altFrontColor');
        this.getSectionByType(SectionType.LEGS).text = this.scenePreview.$t('legs');
        this.getSectionByType(SectionType.HANDLES).text = this.scenePreview.$t('handles');
    }
}
